package com.yogaaicoach.pages.insights.data

import kotlinx.serialization.Serializable

@Serializable
data class GetInsightsResponse(
    val stats: InsightsStats,
    val chartData: ChartData,
    val weeklySummaries: List<WeeklySummaryResponse>
)

@Serializable
data class WeeklySummaryResponse(
    val weekStart: String,          // "2026-03-16" (Monday)
    val totalMinutes: Int,
    val sessions: Int,
    val changePercent: Int?,
    val workouts: List<WorkoutEntryResponse>
)

@Serializable
data class WorkoutEntryResponse(
    val weekday: String,            // "Mon", "Tue", …
    val focusAreas: List<String>,
    val durationMin: Int
)

@Serializable
data class InsightsStats(
    val totalTime: Int,
    val sessions: Int,
    val averageTimeInWeek: Int,
    val bestWeekTime: Int
)

@Serializable
data class ChartData(
    val monthly: List<MonthlyChartPoint>,
    val weekly: List<WeeklyChartPoint>
)

@Serializable
data class MonthlyChartPoint(
    val period: String,    // "2026-03"
    val minutes: Int
)

@Serializable
data class WeeklyChartPoint(
    val weekStart: String, // "2026-03-23" (Monday)
    val minutes: Int
)
